<template>
    <div class="c-sitemap">
        <div class="head-box"><navBar :isNav2="true"></navBar></div>
        <div class="content">
            <!-- 面包屑 -->
            <div class="breadbox">
                <div class="container1">
                    <div class="f_cont">
                        <router-link to="/">首页</router-link>
                        <span>&gt;</span>
                        <a href="javascript:;">网站地图</a>
                    </div>
                </div>
            </div>
            <!-- 网站地图内容1 -->
            <div class="c-sitemap-1">
                <div class="container1">
                    <ul class="c-list">
                        <li>
                            <router-link class="pingFang-Bold font18" to="/">首页</router-link>
                        </li>
                        <li>
                            <router-link class="pingFang-Bold font18" to="">关于我们</router-link>
                            <router-link to="">企业简介</router-link>
                            <router-link to="">加入我们</router-link>
                            <router-link to="">招聘信息</router-link>
                        </li>
                        <li>
                            <router-link class="pingFang-Bold font18" to="">开店数字化</router-link>
                            <router-link to="">上上参谋</router-link>
                            <router-link to="">上上参谋企业版</router-link>
                        </li>
                        <li>
                            <router-link class="pingFang-Bold font18" to="">数据服务</router-link>
                            <router-link to="">数位数采</router-link>
                            <router-link to="">数位观察</router-link>
                        </li>
                        <li>
                            <router-link class="pingFang-Bold font18" to="">资讯中心</router-link>
                            <router-link to="">数位动态</router-link>
                            <router-link to="">媒体报道</router-link>
                            <router-link to="">行业资讯</router-link>
                        </li>
                        <li>
                            <router-link class="pingFang-Bold font18" to="">其他页面</router-link>
                            <router-link to="">免责声明</router-link>
                            <router-link to="">隐私政策</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navBar from '../components/navBar.vue';
export default {
    name: '',
    data() {
        return {};
    },
    created() {},
    mounted() {
        setTimeout(() => {
            this.setDomAnimate(tagIndex => {
                console.log(tagIndex);
                if (tagIndex == 0) {
                    this.setModuleAnimate('us1Animate', 'animate-fadeInUp-module');
                }
            });
        }, 500);
    },
    computed: {},
    methods: {},
    components: { navBar },
    beforeDestroy() {},
    watch: {}
};
</script>

<style scoped lang="less">
::v-deep .navBar-box {
    z-index: 100;
    background: #fff;
    box-shadow: 0 4px 40px rgba(50, 51, 51, 0.06);
    .navbar .nav-link {
        color: #333333;
    }
    .navbar .right-box .el-dropdown-link,
    .navbar {
        color: #333;
    }
    .navbar .nav-link .arrow {
        background-image: url(../assets/images/arrow-down2.svg);
    }
    .navbar .navbar-toggler .icon-caidan {
        color: #333;
    }
    .navbar .navbar-collapse {
        @media @max-sm {
            position: absolute;
            top: 80px;
            left: 0;
            width: 100%;
            padding: 0 20px;
            background: #fff;
            overflow: hidden;
        }
    }
    .left-box {
        @media @max-sm {
            display: flex;
            align-items: center;
            height: 60px;
        }
    }
}
.c-sitemap {
    .head-box {
        width: 100%;
        height: 80px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 90;
        background-color: #ffffff;
    }
    // banner
    // 404内容1
    .c-sitemap-1 {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 60px 0;
        min-height: calc(100vh - 80px);
        @media @max-xs {
            min-height: auto;
            margin-bottom: -20px;
        }
        .container1 {
            max-width: 1000px;
        }
        .c-list {
            position: relative;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            &::before {
                content: '';
                position: absolute;
                top: 50px;
                left: 0;
                width: 100%;
                border-top: 1px solid #f2f2f2;
                @media @max-xs {
                    display: none;
                }
            }
            li {
                @media @max-xs {
                    margin-bottom: 20px;
                    width: 33.333%;
                }
            }
            a {
                display: block;
                color: #333;
                margin-bottom: 10px;
                transition: all 0.3s;
                &:first-child {
                    margin-bottom: 50px;
                    @media @max-xs {
                        margin-bottom: 10px;
                    }
                }
                &:hover {
                    color: #eb5405;
                }
            }
        }
    }
}
</style>
